import { Controller } from "@hotwired/stimulus";

// Controls the expanded/collapsed state of the desktop navigation sidebar.
// Persists the collapsed state in a cookie so the server can render the
// correct width on the next request (no flash of the wrong width).
export default class extends Controller {
  static classes = ["collapsed"];
  static values = {
    collapsed: Boolean,
    cookieName: { type: String, default: "sidebar_collapsed" },
    labelExpand: String,
    labelCollapse: String,
  };
  static targets = ["toggle"];

  connect() {
    this.#applyState();
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue;
    this.#persist();
    this.#applyState();
  }

  #applyState() {
    const collapsedClass = this.hasCollapsedClass ? this.collapsedClass : "sidebar--collapsed";
    this.element.classList.toggle(collapsedClass, this.collapsedValue);

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", String(!this.collapsedValue));
      const label = this.collapsedValue ? this.labelExpandValue : this.labelCollapseValue;
      if (label) {
        this.toggleTarget.setAttribute("aria-label", label);
        this.toggleTarget.setAttribute("title", label);
      }
    }
  }

  #persist() {
    const oneYear = 60 * 60 * 24 * 365;
    document.cookie = `${this.cookieNameValue}=${this.collapsedValue}; path=/; max-age=${oneYear}; SameSite=Lax`;
  }
}
